import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import exact from 'prop-types-exact';
import HeaderTags from '../headerTags/HeaderTags';

const DynamicTitleComponent = (props) => {
    if (props.playerStatus === 'playing' && props.artist && props.song) {
        const title = `${props.artist} - ${props.song}`;

        return (
            <HeaderTags title={title} meta={props.defaultTags.meta} />
        );
    }

    return <HeaderTags title={props.defaultTags.title} meta={props.defaultTags.meta} />;
};

DynamicTitleComponent.propTypes = exact({
    defaultTags: PropTypes.shape({
        title: PropTypes.string.isRequired,
        meta: PropTypes.object.isRequired,
    }).isRequired,
    artist: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    song: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    playerStatus: PropTypes.string,
});

const mapStateToProps = (state) => {
    const aovivoBar = state.aovivoBar;
    const music = aovivoBar.Player?.isLive === 'otherMedia'
        ? aovivoBar.NowPlaying.music
        : aovivoBar.NowPlaying.musicLive;

    return {
        artist: music.artist,
        song: music.song,
        playerStatus: aovivoBar.MediaPlayer.playerStatus,
    };
};

// passing an empty object for mapDispatchToProps to avoid dispatch being passed on and causing prop-types-exact to complain
export default connect(mapStateToProps, {})(DynamicTitleComponent);
